module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_2-65fd09f11d33eb392f343ea15bdc7166.webp";